
import { API } from './api';

const API_SLUG = 'post/v1';

export default class FilterPostApiv2 {

	constructor() {
        let config = {
            feature: API_SLUG
        }
        this.sampleAPI = new API(config);
	}

	load = (reqObj) => {
        return this.sampleAPI.call('load', reqObj);
	}
}